// Universal loading indicator. Default form is a centred block with the
// spinner above an optional label, used for full-page / full-card loading
// states. Pass `inline` for a small inline-flex variant suitable for
// captions ("Loading packages…" inside a sentence).
//
// For totally bare uses (e.g. inside an absolute-positioned overlay where
// you want only the spinner with custom positioning), render a plain
// <span className="loader" /> with inline width/height/borderWidth instead.

export default function Loader({
  label,
  size = 36,
  inline = false,
  className = '',
}) {
  const borderWidth = size <= 20 ? 2 : 3;
  const spinner = (
    <span
      className="loader"
      style={{ width: size, height: size, borderWidth }}
      aria-hidden="true"
    />
  );

  if (inline) {
    return (
      <span
        role="status"
        aria-live="polite"
        className={`d-inline-flex align-items-center gap-2 text-muted small ${className}`}
      >
        {spinner}
        {label && <span>{label}</span>}
      </span>
    );
  }

  return (
    <div
      role="status"
      aria-live="polite"
      className={`text-center text-muted py-5 ${className}`}
    >
      {spinner}
      {label && <div className="mt-2 small">{label}</div>}
    </div>
  );
}
